"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var maxBy_1 = __importDefault(require("lodash/maxBy"));
var react_1 = __importDefault(require("react"));
var UnknownRenderer_1 = require("./UnknownRenderer");
var JsonFormsContext_1 = require("./JsonFormsContext");
/**
 * Dispatch renderer component for cells.
 */
var Dispatch = /** @class */ (function (_super) {
    __extends(Dispatch, _super);
    function Dispatch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dispatch.prototype.render = function () {
        var _a = this.props, uischema = _a.uischema, schema = _a.schema, path = _a.path, cells = _a.cells, id = _a.id, enabled = _a.enabled;
        var cell = maxBy_1.default(cells, function (r) { return r.tester(uischema, schema); });
        if (cell === undefined || cell.tester(uischema, schema) === -1) {
            return react_1.default.createElement(UnknownRenderer_1.UnknownRenderer, { type: 'cell' });
        }
        else {
            var Cell = cell.cell;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Cell, { uischema: uischema, schema: schema, enabled: enabled, path: path, id: id })));
        }
    };
    return Dispatch;
}(react_1.default.Component));
exports.DispatchCell = JsonFormsContext_1.withJsonFormsDispatchCellProps(Dispatch);
//# sourceMappingURL=DispatchCell.js.map